import { AuditoryReactions } from '../../../enums/AuditoryReaction';

export class RandomNumberGenerator {
  MULTIPLIER = 14945; //Often called a (32 bit numbers)
  INCREMENT = 6262; //often called b or c
  MODULUS = 21089;
  seed;
  initialSeed;
  methodCallCount = 0;
  constructor(seed: number) {
    this.seed = (seed || Date.now()) % this.MODULUS;
    this.initialSeed = this.seed;
  }

  gelCalculationLogs(sum: any, isCorrect: boolean, duration: number) {
    // console.log('seed investigation in RND - ', this.seed, 'initial seed - ', this.initialSeed)
    console.log(`[ReactionTaskSubComponentCalculation] Sum: ${sum}, Correct: ${isCorrect},  Modulus: ${this.MODULUS}, Multiplier: ${this.MULTIPLIER},
     Increment: ${this.INCREMENT}, Initial seed: ${this.initialSeed} Current Seed/Last Value: ${this.seed}, # of times advanced: ${this.methodCallCount}`);
  }

  nextMax(maxValue: number) {
    return Math.floor(this.random() * maxValue);
  }

  nextBool() {
    let result = this.nextMax(2);
    return result !== 0;
  }

  randomAngle() {
    let random = this.random() * 2 - 1; // map the number from [0..1] to [-1 .. 1]

    // Convert the range to [-π, π] and return the result
    return random * Math.PI;
  }

  between(min: number, max: number) {
    // Convert the range to [min, max] and round down to the nearest integer
    return Math.floor(this.random() * (max - min)) + min;
  }
  animationPause(min: number, max: number): number {
    if (max <= min) {
      return min;
    }
    return this.random() * (max - min) + min;
  }

  testAnimationPause(min: number, max: number): void {
    let txt = `--- Testing animationPause(${min}, ${max}) ---\n`;
    for (let i = 1; i <= 20; i++) {
      const pause = this.animationPause(min, max);
      txt += `Iteration ${i}: ${pause.toFixed(3)}\n`;
    }
    console.log(txt, this.seed);
  }

  pickAValue(valueA: number | boolean, ValueB: number | boolean) {
    // If the random number is less than 0.5, return valueA, otherwise return valueB
    return this.random() < 0.5 ? valueA : ValueB;
  }

  pickAudioReaction(values: AuditoryReactions[]) {
    let index = Math.floor(this.random() * values.length);
    // Return the value at the random index
    return values[index];
  }

  pickNewDuration(min: number, max: number) {
    return Math.floor(this.random() * (max - min + 1)) + min;
  }

  // Increase the seed and return it, a value between [0 .. MODULUS]
  advanceSeed() {
    this.methodCallCount++;
    this.seed = (this.MULTIPLIER * this.seed + this.INCREMENT) % this.MODULUS;
    return this.seed;
  }

  randomBouncingAngle(prevNumber: number | undefined) {
    let index = this.advanceSeed() / (this.MODULUS + 1);

    if (prevNumber === undefined) {
      return index;
    } else {
      let lowerBound = Math.max(0, prevNumber - 0.3);
      let upperBound = Math.min(1, prevNumber + 0.3);

      if (index < lowerBound || index > upperBound) {
        return index;
      } else {
        if (index < prevNumber) {
          return (index - 0.3 + 1) % 1;
        } else {
          return (index + 0.3) % 1;
        }
      }
    }
  }

  newRandomSeed() {
    // Generate a new seed based on the random method
    let newSeed = Math.floor(this.random() * this.initialSeed);
    // Set the new seed
    this.seed = newSeed;
    this.initialSeed = newSeed;

    // Return the new seed
    return newSeed;
  }

  // Return a random value between [0 .. 1]
  random() {
    return this.advanceSeed() / (this.MODULUS + 1);
  }
}
